import getQueryParams from '@/utilities/getters/getQueryParams';

const STATIC_PATH_SEGMENTS = new Set(['plc-plugin', 'test-ui']);

/**
 * Resolves the active game UID from the current URL (path param or query).
 * Safe to call outside React — used for soft reload vitals after store resets.
 */
export const getGameUidFromLocation = (): string | undefined => {
  const queryGameUid = getQueryParams('gameUid');
  if (queryGameUid) {
    return queryGameUid;
  }

  const segments = window.location.pathname.split('/').filter(Boolean);
  const lastSegment = segments.at(-1);

  if (lastSegment && !STATIC_PATH_SEGMENTS.has(lastSegment)) {
    return lastSegment;
  }

  return undefined;
};
